import { Flex, Skeleton, Row, Col } from "antd";

export const SkeletonTableTabs = ({ withTabs = true, withSearchBar = true, rows = 6 }) => {
    const rowStyle = {
        width: "100%",
        height: "1rem",
        marginBottom: "1.5rem",
    };

    return (
        <>
            {withTabs && (
                <Flex className="mb-2 mt-2" gap="1rem">
                    <Skeleton.Button active={true} />
                    <Skeleton.Button active={true} />
                    <Skeleton.Button active={true} />
                    <Skeleton.Button active={true} />
                    <Skeleton.Button active={true} />
                </Flex>
            )}

            {withSearchBar && <Skeleton.Button active={true} className="instrument__tabs__search-bar" />}

            <Row gutter={8}>
                <Col xs={12} md={8} lg={4}>
                    <Flex vertical className="instrument__tabs__table-column">
                        {Array.from({ length: rows }, (_, i) => i + 1).map((item) => (
                            <Skeleton.Button active={true} key={item} />
                        ))}
                    </Flex>
                </Col>
                <Col xs={12} md={8} lg={4}>
                    <Flex vertical className="instrument__tabs__table-column">
                        {Array.from({ length: rows }, (_, i) => i + 1).map((item) => (
                            <Skeleton.Button active={true} key={item} />
                        ))}
                    </Flex>
                </Col>
                <Col xs={12} md={8} lg={4}>
                    <Flex vertical className="instrument__tabs__table-column">
                        {Array.from({ length: rows }, (_, i) => i + 1).map((item) => (
                            <Skeleton.Button active={true} key={item} />
                        ))}
                    </Flex>
                </Col>
                <Col xs={12} md={8} lg={4}>
                    <Flex vertical className="instrument__tabs__table-column">
                        {Array.from({ length: rows }, (_, i) => i + 1).map((item) => (
                            <Skeleton.Button active={true} key={item} />
                        ))}
                    </Flex>
                </Col>
                <Col xs={12} md={8} lg={4}>
                    <Flex vertical className="instrument__tabs__table-column">
                        {Array.from({ length: rows }, (_, i) => i + 1).map((item) => (
                            <Skeleton.Button active={true} key={item} />
                        ))}
                    </Flex>
                </Col>
                <Col xs={12} md={8} lg={4}>
                    <Flex vertical className="instrument__tabs__table-column">
                        {Array.from({ length: rows }, (_, i) => i + 1).map((item) => (
                            <Skeleton.Button active={true} key={item} />
                        ))}
                    </Flex>
                </Col>
            </Row>
        </>
    );
};
